import { MarketingLayout } from "@/components/marketing/marketing-layout";
import { LegalPageView } from "@/components/legal/legal-page";
import { LEGAL_PAGES } from "@/lib/legal";
import { useDocumentHead } from "@/lib/document-head";

export function RefundsPage() {
  useDocumentHead({
    title: "Refund Policy | Swift MVP",
    description:
      "Swift MVP's money-back guarantee and refund process. Refund requests are resolved within 48 hours.",
    canonical: "/refunds",
  });
  return (
    <MarketingLayout>
      <div className="mx-auto max-w-3xl px-6 py-12">
        <LegalPageView page={LEGAL_PAGES.refunds} />
      </div>
    </MarketingLayout>
  );
}
